import React from 'react'

function AddPlanHead() {
    return (
        <div className="formbold-main-wrapper add-plan-wrapper" style={{paddingBottom:'10px'}}>
                    <div className="formbold-form-wrapper add-plan-form add-plan-head">
                        <h5>Add A Prepaid Plan</h5> 
                    </div>
        </div>
    )
}

export default AddPlanHead